import IDirectionData from "../direction/directionData";
import IPropertyType from "../propertyType/PropertyTypeData";

export interface IInstrumentProperty {
  id: string;
  name: string;
  instrumentPropertyId: string;
  instrumentPropertyName: string;
  direction: IDirectionData[];
  min?: number | string;
  max?: number | string;
  customId: number;
  unit: string;
  decimals: number;
  description: string;
  isNew: boolean;
  type: IPropertyType;
  uniqueId?: string;

  // Required For Mapping
  selectedProperty: any[];
  selectedDirection: any[];
  isDisabled?: boolean;
  isError?: boolean;
  isEdited?: boolean;
}

export class InstrumentProperty implements IInstrumentProperty {
  id: string;
  name: string;
  instrumentPropertyId: string;
  instrumentPropertyName: string;
  direction: IDirectionData[];
  min?: number | string;
  max?: number | string;
  customId: number;
  unit: string;
  decimals: number;
  description: string;
  isNew: boolean;
  type: IPropertyType;
  uniqueId?: string;
  selectedProperty: any[];
  selectedDirection: any[];
  isDisabled?: boolean;
  isError?: boolean;
  isEdited?: boolean;

  constructor(
    id: string,
    name: string,
    instrumentPropertyId: string,
    instrumentPropertyName: string,
    direction: IDirectionData[],
    min: number | string,
    max: number | string,
    customId: number,
    unit: string,
    decimals: number,
    description: string,
    isNew: boolean,
    type: IPropertyType,
    uniqueId?: string,
    isDisabled?: boolean,
    isError?: boolean,
    isEdited?: boolean
  ) {
    this.id = id;
    this.name = name;
    this.instrumentPropertyId = instrumentPropertyId;
    this.instrumentPropertyName = instrumentPropertyName;
    this.direction = direction;
    this.min = min;
    this.max = max;
    this.customId = customId;
    this.unit = unit;
    this.decimals = decimals;
    this.description = description;
    this.isNew = isNew;
    this.type = type;
    this.uniqueId = uniqueId;
    this.isDisabled = isDisabled || false;
    this.isError = isError;
    this.isEdited = isEdited;
  }
}
